import {css} from 'styled-components';

const sizes = {
    smallPhone: 320,
    phone360: 360,
    res720: 720,
    phones: 768,
    tablets: 992,
    height450: 450,
    height880: 880,
    height755: 755,
    height645: 645,
    height580: 580,
    heightSmall: 540,
};


// Iterate through the sizes and create a media template
const media = Object.keys(sizes).reduce((acc, label) => {
    acc[label] = (...args) => css `
      @media (max-width: ${sizes[label] / 16}em) {
        ${css(...args)}
      }
    `;
    return acc
}, {});

export const mediaHeights = Object.keys(sizes).reduce((acc, label) => {
    acc[label] = (...args) => css `
      @media (max-height: ${sizes[label] / 16}em) {
        ${css(...args)}
      }
    `;
    return acc
}, {});

export default media;